import { useEffect, useRef, useState } from 'react';
import { Camera, RotateCcw } from 'lucide-react';
import { toast } from 'sonner';

export default function FaceCapture({ value, onChange }) {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [live, setLive] = useState(false);

  const stopCam = () => {
    streamRef.current?.getTracks().forEach((t) => t.stop());
    streamRef.current = null;
    setLive(false);
  };
  useEffect(() => stopCam, []);

  const start = async () => {
    try {
      const s = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: 320, height: 320 } });
      streamRef.current = s;
      setLive(true);
      setTimeout(() => { if (videoRef.current) { videoRef.current.srcObject = s; videoRef.current.play(); } }, 0);
    } catch { toast.error('Camera permission denied'); }
  };
  const snap = () => {
    const v = videoRef.current;
    const side = Math.min(v.videoWidth, v.videoHeight) || 240;
    const c = document.createElement('canvas');
    c.width = 240; c.height = 240;
    c.getContext('2d').drawImage(v, (v.videoWidth - side) / 2, (v.videoHeight - side) / 2, side, side, 0, 0, 240, 240);
    onChange(c.toDataURL('image/jpeg', 0.8));
    stopCam();
  };

  if (value) {
    return (
      <div className="flex items-center gap-3" data-testid="face-capture-done">
        <img src={value} alt="Your live photo" className="w-16 h-16 rounded-xl object-cover border-2 border-[#1B5E20]"/>
        <button type="button" data-testid="face-capture-retake" onClick={() => onChange(null)} className="pill !bg-white text-xs"><RotateCcw className="w-3 h-3"/>Remove</button>
      </div>
    );
  }
  if (live) {
    return (
      <div className="flex items-center gap-3">
        <video ref={videoRef} muted playsInline className="w-24 h-24 rounded-xl object-cover bg-ink -scale-x-100"/>
        <button type="button" data-testid="face-capture-snap" onClick={snap} className="btn-primary !py-2 !px-3 text-xs"><Camera className="w-4 h-4"/>Take photo</button>
      </div>
    );
  }
  return (
    <button type="button" data-testid="face-capture-start" onClick={start} className="pill !bg-white text-xs"><Camera className="w-3.5 h-3.5"/>Add live face photo</button>
  );
}
